import * as ActionTypes from './actionTypes';

export const setError = (error) => ({
    type: ActionTypes.SET_ERROR,
    payload: error
});

export const clearError = () => ({
    type: ActionTypes.CLEAR_ERROR
});

export const errors = (state = null, action) => {
    switch (action.type) {
        case ActionTypes.SET_ERROR:
            return action.payload;
        case ActionTypes.CLEAR_ERROR:
            return null;
        default:
            return state;
    }
};

